module.exports = __webpack_public_path__ + "57653435eedd64745c5c3ef877ad3b10.pdf";